import {
	EuiFieldText,
	EuiFormRow,
} from '@equipmentshare/ds2'

export type ProductClassFormProps = {
	formState: ProductClassFormState,
	setFormState: ( formState: ProductClassFormState ) => void,
}

export type ProductClassFormState = {
	catClass: string,
	categoryName: string,
	classification: string,
	validation: {
		catClass: {
			isInvalid: boolean,
			error?: string,
		},
		categoryName: {
			isInvalid: boolean,
			error?: string,
		},
		classification: {
			isInvalid: boolean,
			error?: string,
		},
	},
}

export default function ProductClassForm( { formState, setFormState }: ProductClassFormProps ) {
	const onChangeField = ( fieldName: 'catClass' | 'categoryName' | 'classification' ) => ( event: React.ChangeEvent<HTMLInputElement> ) => setFormState( {
		...formState,
		[ fieldName ]: event.currentTarget.value,
		validation: {
			...formState.validation,
			[ fieldName ]: { isInvalid: false },
		},
	} )

	return (
		<>
			<EuiFormRow
				label={<>CAT/CLASS number <span className="required">*</span></>}
				{...formState.validation.catClass}
			>
				<EuiFieldText
					value={formState.catClass}
					isInvalid={formState.validation.catClass.isInvalid}
					onChange={onChangeField( 'catClass' )}
				/>
			</EuiFormRow>

			<EuiFormRow
				label={<>Category name <span className="required">*</span></>}
				{...formState.validation.categoryName}
			>
				<EuiFieldText
					value={formState.categoryName}
					isInvalid={formState.validation.categoryName.isInvalid}
					onChange={onChangeField( 'categoryName' )}
				/>
			</EuiFormRow>

			<EuiFormRow
				label={<>Classification <span className="required">*</span></>}
				{...formState.validation.classification}
			>
				<EuiFieldText
					value={formState.classification}
					isInvalid={formState.validation.classification.isInvalid}
					onChange={onChangeField( 'classification' )}
				/>
			</EuiFormRow>
		</>
	)
}
